import React, { useRef, useState } from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";
import UIModal from "../../../Domain/Components/UI/Modal/Modal";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";

function CampaignTenantListPage(props) {
    return(
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            deleteModalTitile={"Delete Campaign Tenant"}
                            deleteModalQuestion={"Are you sure you want to delete this campaign Tenant?"}
                            editHref={"/campaign-tenant/update"}
                            detailsHref={"/campaign-tenant/details"}
                            objectKeys={["id", "campaign.name", "campaign.tenant.external_id"]}
                            columnTitles={[ 
                                "ID", "Campaign", "Tenant"
                            ]}
                            insertHref={"/campaign-tenant/create"}
                            insertTitle={"Add Campaign Tenant"}
                            pageTitle={"Campaign Tenants"}
                            deleteEndpoint={"campaign-tenant/delete"}
                            readEndpoint={"campaign-tenant/read"}
                            relations={["campaign", "tenant",]}
                            />
        </>
    )
}

export default CampaignTenantListPage;